import { Grid, Hidden, makeStyles, Theme, Typography } from '@material-ui/core';
import axios from 'axios';
import React from 'react';
import Countdown from 'react-countdown';
import { useHistory } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import Menu from '../MenuBar/Menu/Menu';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: 'white',
    paddingLeft: '1em',
    display: 'none',
    height: `${theme.mobileTopBarHeight}px`,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  endCallButton: {
    height: '28px',
    fontSize: '0.85rem',
    padding: '0 0.6em',
  },
  settingsButton: {
    [theme.breakpoints.down('sm')]: {
      height: '28px',
      minWidth: '28px',
      border: '1px solid rgb(136, 140, 142)',
      padding: 0,
      margin: '0 1em',
    },
  },
}));

interface MobileTopMenuBarProps {
  sessionDetails?: any;
}

export default function MobileTopMenuBar({ sessionDetails }: MobileTopMenuBarProps) {
  const classes = useStyles();
  const { room } = useVideoContext();
  var timeStamp = Date.now() + 1800000;
  const history = useHistory();

  if (sessionDetails?.end) {
    const isoString = sessionDetails?.end?.dateTime;

    const date = new Date(isoString);

    timeStamp = date.getTime();
  }

  const handleComplete = () => {
    room!.disconnect();
    axios
      .post(`${process.env.REACT_APP_SERVER_BASE_URL}/room/complete`, {
        room_sid: room?.sid,
      })
      .then(res => {
        history.push(`/end/${room?.name}?sess=${sessionDetails?._id}`);
      })
      .catch(Err => {
        console.log('Error on Disconnecting from room', Err);
      });
  };

  return (
    <Grid container alignItems="center" justifyContent="space-between" className={classes.container}>
      <Typography variant="subtitle1">{room!.name}</Typography>
      <Grid style={{ display: 'flex' }}>
        <Hidden mdUp>
          <Grid style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Countdown date={timeStamp} autoStart={true} zeroPadTime={2} zeroPadDays={0} onComplete={handleComplete} />
          </Grid>
        </Hidden>
        <Menu buttonClassName={classes.settingsButton} />
      </Grid>
    </Grid>
  );
}
